module.exports = __webpack_public_path__ + "static/img/supplier_icon.4cdb24c2.svg";